import { FC, Fragment, InputHTMLAttributes } from "react";

export type InputTextRightprops = InputHTMLAttributes<HTMLInputElement> & {
  label: string;
  spanRight?: string;
  inputLarge?: boolean;
};

export const InputTextRight: FC<InputTextRightprops> = ({
  label,
  spanRight,
  inputLarge,
  ...props
}) => {
  return (
    <Fragment>
      <div>
        <label
          htmlFor="price"
          className="block text-sm font-medium leading-6 text-gray-900"
        >
          {label}
        </label>
        <div className="relative rounded-md shadow-sm">
          <input
            {...props}
            className={`block w-full px-2 rounded-md border-0 py-1.5 ${
              inputLarge ? "pr-[70px]" : "pr-12"
            }  text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
          />
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
            <span id="price-currency" className="text-gray-500 sm:text-sm">
              {spanRight}
            </span>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
